<template>
	<div class="main">
		<div v-html="details.txt" class="inner-content">

		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		data () {
			return {
				details: {}
			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../static/top_banner_2.png'
			that.getInfo()
		},
		methods: {
			getInfo() {
				let that = this

				that.$http.post({
					url: '/api/channel/findContentListByChannelId',
					data: {
						channelId: that.$store.state.channelId,
						releaseTerrace: "releasePc"
					}
				}).then(res => {
					if(res.code === 'S200') {
						res.data.some(item => {
							if(item.channelId == that.$store.state.channelId) {
								that.details = item
								return true
							}
						})
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.main {
		width: 74%;
		margin: 18px 13% 80px;
		font-size: 12px;
		color: #333333;
		.cgxz {
			text-align: left;
			display: flex;
			height: 30px;
			line-height: 30px;
			justify-content: space-between;
			.cgxz-left {
				color: #264EA7;
				font-size: 13px;
				margin-right: 10px;
				width: 6%;
			}
			.cgxz-right {
				height: 16px;
				width: 94%;
				border-bottom: 2px solid #EDD68E;
			}
		}
		.lpxz {
			text-align: left;
			display: flex;
			height: 30px;
			line-height: 30px;
			justify-content: space-between;
			.cgxz-left {
				color: #264EA7;
				font-size: 13px;
				margin-right: 10px;
				width: 10%;
			}
			.cgxz-right {
				height: 16px;
				width: 90%;
				border-bottom: 2px solid #EDD68E;
			}
		}
		.cgxz-js {
			text-align: left;
			font-size: 12px;
			color: #686868;
			margin: 10px;
			line-height: 22px;
			.qrcode {
				display: flex;
				.img-label {
					width: 60px;
					height: 90px;
					margin: 20px;
					img {
						width: 60px;
						height: 60px;
					}
				}

			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/visit_service/cgzn.vue